import request from '../../../shared/request'

export function getScheduleApplicationDates(job_id) {
  return request(`/job/schedules/${job_id}/application`)
}

export function addScheduleApplicationDates(payload) {
  return request(`/job/schedules/${payload.job_id}/application`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteScheduleApplication(payload) {
  return request(`/job/schedules/${payload.schedule_id}/application`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateScheduleApplicationDates(payload) {
  return request(`/job/schedules/${payload.job_id}/application`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateScheduleApplicationNotes(payload) {
  return request(`/job/schedules/${payload.job_id}/application/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/scheduleApplications.js